export const SET_DATA = "SET_DATA";
export const EDIT_DATA = "EDIT_DATA";
export const DELETE_DATA = "DELETE_DATA";
export const SET_USERID = "SET_USERID";
export const SET_LOGOUT = "SET_LOGOUT";
